import Logo from '../ui/Logo';

const COLUMNS = [
  { title: 'For Learners',  links: ['Browse Courses', 'Find a Tutor', 'Quizzes & Practice', 'Certificates', 'Flashcards', 'Mobile App', 'Pricing'] },
  { title: 'For Providers', links: ['Launch a Course', 'Lincoln for Schools', 'Lincoln for Ministries', 'Lincoln for Tutoring', 'API & Integrations', 'Become a Partner', 'Pricing'] },
  { title: 'Case Studies',  links: ['Malta · Public Schools', 'Finland · National AI', 'WEF Partnership', 'US · Vocational', 'Glowie · Finland', 'Tutoring · Global', 'All case studies'] },
  { title: 'Company',       links: ['About Lincoln', 'Our Team', 'Press Kit', 'Careers', 'Trust & Safety', 'Accessibility', 'Contact'] },
];

export default function Footer() {
  return (
    <footer style={{ background: 'var(--navy-2)', color: 'rgba(255,255,255,0.7)' }}>
      {/* Main columns */}
      <div className="lc-container" style={{ padding: '64px 40px 40px' }}>
        <div className="grid" style={{ gridTemplateColumns: '1.4fr repeat(4, 1fr)', gap: 48 }}>
          <div>
            <Logo inverted />
            <p className="mt-5 leading-relaxed" style={{ fontSize: 14, maxWidth: 280 }}>
              A school you can talk to. Built in Finland. Used in classrooms from Malta to California, partnered with the World Economic Forum.
            </p>

            <div className="flex gap-2.5 mt-5">
              {[['f', 'Facebook'], ['𝕏', 'Twitter/X'], ['in', 'LinkedIn']].map(([s, l]) => (
                <a key={l} href="#" title={l} className="inline-flex items-center justify-center rounded-full font-bold text-white" style={{ width: 36, height: 36, background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)', fontSize: 13 }}>{s}</a>
              ))}
            </div>
          </div>

          {COLUMNS.map((c) => (
            <div key={c.title}>
              <div className="font-bold text-white uppercase tracking-widest mb-4" style={{ fontSize: 13 }}>{c.title}</div>
              <ul className="flex flex-col gap-2.5 list-none p-0 m-0">
                {c.links.map((l) => (
                  <li key={l}><a href="#" style={{ fontSize: 14, color: 'rgba(255,255,255,0.7)' }}>{l}</a></li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Language */}
        <div className="mt-10 pt-7" style={{ borderTop: '1px solid rgba(255,255,255,0.06)' }}>
          <div className="font-bold uppercase tracking-widest mb-2.5" style={{ fontSize: 11, color: 'rgba(255,255,255,0.45)' }}>Site language</div>
          <div className="flex flex-wrap gap-1.5">
            {['🇺🇸 English', '🇲🇹 Malti', '🇵🇰 اردو'].map((l) => (
              <button key={l} type="button" className="rounded-full font-medium" style={{ fontSize: 12, padding: '5px 10px', background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)', color: 'rgba(255,255,255,0.75)' }}>{l}</button>
            ))}
          </div>
        </div>

        <div className="mt-9 pt-6 flex justify-between items-center flex-wrap gap-4" style={{ fontSize: 13, borderTop: '1px solid rgba(255,255,255,0.06)' }}>
          <div>© 2026 Lincoln School</div>
          <div className="flex gap-6">
            <a href="#">Privacy</a><a href="#">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
